module.exports = __webpack_public_path__ + "img/FSM.d65401bd.svg";